import { FunctionComponent, useEffect, useState } from "react";
import IntBarTable from "../IntBarTable/IntBarTable";
import commonStyles from "../../CommonStyles/CommonGraphStyles.module.css";
import Chart from "react-apexcharts";
import { connect } from "react-redux";
import { themeColors } from "../../Components/theme";
import { CSVLink } from "react-csv";
import { DownloadReportCsv } from "../CommanDownloadFunction";
import { Box, Grid, useMediaQuery, useTheme } from "@mui/material";
import "../../theme-vars.css";

type props = {
  state: any;
  interestedState: any;
  history: any;
  filter: "MTD" | "YTD" | "PM" | "All" | "CUSTOM";
  analyticsData: any;
  usersList: any;
  checked: boolean;
  teamsData: any;
  source: boolean;
  taskFilters?: any;
  leadFilters?: any;
  callFilters?: any;
  durationData?: any;
  theme: any;
  showTrendAnalytics?: boolean;
  setShowTrendAnalytics?: any;
};

const Trends: FunctionComponent<props> = ({
  state,
  interestedState,
  history,
  filter,
  analyticsData,
  usersList,
  checked,
  teamsData,
  source,
  taskFilters,
  leadFilters,
  callFilters,
  durationData,
  theme,
  showTrendAnalytics,
  setShowTrendAnalytics
}) => {

  /** ----------------------------------------------
*  Responsive Logic (MUI Breakpoints)
* ---------------------------------------------- */
  const themeMUI = useTheme();
  const isMobile = useMediaQuery(themeMUI.breakpoints.down("sm"));

  /** ----------------------------------------------
*  CSV Download Data State
* ---------------------------------------------- */
  const [durationReportData, setDurationReportData] = useState<any>([]);
  const [durationReportHeader, setDurationReportHeader] = useState<any>([]);

  /** ------------------------------------------------
* Extract headers from callback reason data
* ------------------------------------------------ */
  useEffect(() => {
    let headerArray: any[] = [];
    durationData?.map((list: any) => {
      return list?.duration?.map((li: any) => {
        return headerArray.push(li.duration);
      })
    })
    setDurationReportHeader(headerArray)
  }, [durationData]);

  /** ------------------------------------------------
* Download CSV
* ------------------------------------------------ */
  const downLoadReport = () => {
    let filterData: any[] = [];
    const csvReportData = DownloadReportCsv(durationData, durationReportHeader, usersList, "duration");
    csvReportData.map((list: any) => {
      return filterData.push({ "name": list.name, "total": list.total, "(0)sec": list[0], "(0-30)sec": list[30], "(31-60)sec": list[60], "(61-120)sec": list[120], "(>120)sec": list.Other })
    })
    setDurationReportData(filterData);
  }

  /** ------------------------------------------------
* Area Chart Options
* ------------------------------------------------ */
  const areaChartOptions: any = {
    options: {
      chart: {
        animations: {
          enabled: false,
        },
        background: theme ? 'rgba(0, 0, 0, 0)' : 'rgba(26, 43, 60, 1)',
        id: "apexchart-example",
        toolbar: {
          show: true,
          offsetX: 0,
          offsetY: 0,
          tools: {
            download: true,
            customIcons: []
          },
          export: {
            csv: {
              filename: undefined,
              columnDelimiter: ',',
              headerCategory: 'category',
              headerValue: 'value',
            },
            svg: {
              filename: undefined,
            },
            png: {
              filename: undefined,
            }
          },
          autoSelected: 'zoom'
        }
      },
      xaxis: {
        categories: state.labels,
        tooltip: {
          enabled: false,
        },
        labels: {
          show: true,
          style: {
            colors: theme ? "#000" : "#fff",
          },
        },
      },
      yaxis: {
        tooltip: {
          enabled: false,
        },
        labels: {
          show: true,
          style: {
            colors: theme ? "#000" : "#fff",
          },
        },
      },
      colors: ["#71CACC"],
    },
    series: [
      {
        name: "Calls",
        data: state.datasets[0].data,
      },
    ],
  };

  /** ------------------------------------------------
* Area Chart Options 2nd
* ------------------------------------------------ */
  const areaChartOptions2: any = {
    options: {
      chart: {
        animations: {
          enabled: false,
        },
        background: theme ? 'rgba(0, 0, 0, 0)' : 'rgba(26, 43, 60, 1)',
        id: "apexchart-example",
        toolbar: {
          show: true,
          offsetX: 0,
          offsetY: 0,
          tools: {
            download: true,
            customIcons: []
          },
          export: {
            csv: {
              filename: undefined,
              columnDelimiter: ',',
              headerCategory: 'category',
              headerValue: 'value',
            },
            svg: {
              filename: undefined,
            },
            png: {
              filename: undefined,
            }
          },
          autoSelected: 'zoom'
        }
      },
      xaxis: {
        categories: interestedState.labels,
        tooltip: {
          enabled: false,
        },
        labels: {
          show: true,
          style: {
            colors: theme ? "#000" : "#fff",
          },
        },
      },
      yaxis: {
        tooltip: {
          enabled: false,
        },
        labels: {
          show: true,
          style: {
            colors: theme ? "#000" : "#fff",
          },
        },
      },
      colors: ["#87CBAC"],
    },
    series: [
      {
        name: "Interested Leads",
        data: interestedState.datasets[0].data,
      },
    ],
  };

  /** ------------------------------------------------
* Width Calculate Function
* ------------------------------------------------ */
  const calculateWidth = () => {
    if (areaChartOptions.series[0].data.length > 10) {
      return areaChartOptions.series[0].data.length * 100;
    } else {
      return "100%";
    }
  }


  /** ------------------------------------------------
* Width Calculate Function 2nd
* ------------------------------------------------ */
  const calculateWidth2 = () => {
    if (areaChartOptions2.series[0].data.length > 10) {
      return areaChartOptions2.series[0].data.length * 100;
    } else {
      return "100%";
    }
  }

  /** ------------------------------------------------
* Reusable styling for tables/cards by theme
* ------------------------------------------------ */
  const tableContainerStyles = { backgroundColor: theme ? themeColors.cardBackgroundColor : themeColors.cardBackgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark }

  /** CSS Variables */
  const fontFamilyMain = "var(--font-family-main)";
  const fontSizeMedium = "var(--font-size-medium)";

  return (
    <>
      <Box
        className={`d-flex flex-column ${isMobile ? 'mb-2' : 'mb-3'}`}
        sx={{
          width: "100%",
          padding: isMobile ? 1 : 0,
        }}
      >

        {/* -------------------------------------------------------
       * Header Section with CSV Download Icon
       * ------------------------------------------------------- */}
        <h6 className={commonStyles.heading} style={{ fontFamily: fontFamilyMain, fontSize: fontSizeMedium, margin: isMobile ? "0px 0px 10px 5px" : "0px 0px 10px 0px" }}>Calling Trend Summary</h6>

        {/* -------------------------------------------------------
       * Content Area (Chart + Table)
       * ------------------------------------------------------- */}
        <Box
          className="card p-4 shadow rounded"
          style={{
            minWidth: "100%",
            maxWidth: "100%",
            minHeight: "400px",
            maxHeight: "400px",
            ...tableContainerStyles
          }}
        >
          <Box
            id="trends"
            style={{
              minWidth: "100%",
              maxWidth: "100%",
              overflowX: "auto",
              color: "#000"
            }}
          >
            <Chart
              options={areaChartOptions.options}
              series={areaChartOptions.series}
              type="area"
              width={calculateWidth()}
              height={280}
            />
          </Box>
        </Box>
        {source === false && (
          <>
            <h6 className={commonStyles.heading} style={{ fontFamily: fontFamilyMain, fontSize: fontSizeMedium, margin: isMobile ? "20px 0px 10px 5px" : "20px 0px 10px 0px" }}>Call Log Summary<CSVLink onClick={downLoadReport} data={durationReportData}><svg style={{ cursor: 'pointer', color: "rgb(39, 159, 159)" }} xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-download" viewBox="0 0 16 16">
              <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
              <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
            </svg></CSVLink></h6>
            <Box
              id="trends"
              className="card p-4 shadow rounded w-100 mt-2 "
              style={{ minHeight: "400px", maxHeight: "400px", marginTop: "-2rem", ...tableContainerStyles }}
            >
              <IntBarTable
                type={"callLogs"}
                data={analyticsData}
                heading={"Call Logs Summary"}
                usersList={usersList}
                checked={checked}
                teamsData={teamsData}
                style={{ width: "100%" }}
                show={false}
                filter={filter}
                history={history}
                source={source}
                taskFilter={taskFilters ? taskFilters : {}}
                leadFilter={leadFilters ? leadFilters : {}}
                callFilter={callFilters ? callFilters : {}}
              />
            </Box>
          </>
        )}
        {
          showTrendAnalytics && (
            <>
              <h6 className={commonStyles.heading} style={{ fontFamily: fontFamilyMain, fontSize: fontSizeMedium, margin: isMobile ? "20px 0px 10px 5px" : "20px 0px 10px 0px" }}>Interested Lead Trend Summary</h6>
              <Box className="card p-4 shadow rounded" style={tableContainerStyles}>
                <Box
                  id="trends"
                  style={{
                    minWidth: "100%",
                    maxWidth: "100%",
                    overflowX: "auto",
                    color: "#000"
                  }}
                >
                  <Chart
                    options={areaChartOptions2.options}
                    series={areaChartOptions2.series}
                    type="area"
                    width={calculateWidth2()}
                    height={280}
                  />
                </Box>
              </Box>
            </>
          )
        }
        {!showTrendAnalytics && (
          <Grid item xs={12} md={12} sx={{ textAlign: "center", marginTop: "1rem" }}>
            <button className={commonStyles.showMoreBox} onClick={() => { setShowTrendAnalytics(!showTrendAnalytics) }}>Show More</button>
          </Grid>
        )}
      </Box>
    </>
  );
};

/**
 * Maps Redux state to component props.
 */
const mapStateToProps = (state: any) => {
  return {
    durationData: state.callLogReportData.data?.report,
    theme: state.theme.isLightMode
  };
};
export default connect(mapStateToProps)(Trends);
